 <div class="catalog-type-container" *ngIf="tabIndex !== 'Smart'">
  <label class="catalog-type-label">{{typeLabel}}</label>
  <nz-radio-group [(ngModel)]="tabIndex" (ngModelChange)="onTabChange($event)">
    <label
     [nzDisabled]="mode === 'edit' && isSmartCatalog === true"
     [@radioAnimation]="tabIndex === 'Manual' ? 'selected' : 'unselected'"
     nz-radio nzValue="Manual">{{manualLabel}}</label>
    <label
      [nzDisabled]="mode === 'edit' && isSmartCatalog === false"
      [@radioAnimation]="tabIndex === 'Smart' ? 'selected' : 'unselected'"
      nz-radio nzValue="Smart">{{smartLabel}}</label>
  </nz-radio-group>

</div>

<div [ngSwitch]="tabIndex">
  <div *ngSwitchCase="'Manual'"></div>
  <div *ngSwitchCase="'Smart'" [@filterSectionAnimation]>
    <div nz-row class="products-conditions-container">
      <div nz-col nzSpan="24" class="header">
        <label class="catalog-type-label">{{typeLabel}}</label>
        <nz-radio-group [(ngModel)]="tabIndex" (ngModelChange)="onTabChange($event)">
          <label 
           [nzDisabled]="mode === 'edit' && isSmartCatalog === true"
           nz-radio 
           nzValue="Manual"
           [@radioAnimation]="tabIndex === 'Manual' ? 'selected' : 'unselected'"
           >{{manualLabel}}
          </label>
          <label 
             [nzDisabled]="mode === 'edit' && isSmartCatalog === false "
             nz-radio 
             nzValue="Smart"
             [@radioAnimation]="tabIndex === 'Smart' ? 'selected' : 'unselected'"
             >{{smartLabel}}
            </label>
          
        </nz-radio-group>
      </div>
      <nz-divider></nz-divider>
      <div nz-col nzSpan="24" class="header-row">

        <nz-radio-group [(ngModel)]="conditionType" class="conditions-radio-group"
          (ngModelChange)="onConditionTypeChange()">
          <span class="products-text">{{'Products must match' | translate}}</span>
          <label nz-radio nzValue="All"
           [@radioAnimation]="conditionType === 'All' ? 'selected' : 'unselected'"
          >{{'All conditions' | translate}}</label>
          <label nz-radio nzValue="Any"
          [@radioAnimation]="conditionType === 'Any' ? 'selected' : 'unselected'"
          >{{'Any condition' | translate}}</label>

        </nz-radio-group>
        <div class="buttons">

          <!-- <button nz-button nzType="primary"
          [disabled]="isApplyDisabled()"
          (click)="applyFilter()">
            <span>{{'Apply'  | translate}}</span>
          </button> -->


          <button nz-button nzType="default" 
          nz-popconfirm
          [nzPopconfirmTitle]="'This will remove all filters and delete all linked products. Proceed with caution!'"
                (nzOnConfirm)="clearCondition()" style="background: none;"
          >{{'Clear' | translate}}
        </button>
        </div>
      </div>

      <div nz-col nzSpan="24" class="condition-row" *ngFor="let condition of conditions; let i = index;trackBy: trackByIndex">

        <nz-select nzAllowClear [(ngModel)]="condition.source" (ngModelChange)="updateList(i)"
          [nzPlaceHolder]="'Select source'  | translate">
           <nz-option *ngFor="let source of sources" [nzLabel]="source.label" [nzValue]="source.value"></nz-option> 
         
        </nz-select>

        <nz-select nzShowSearch nzAllowClear [(ngModel)]="condition.field"
         (ngModelChange)="updateSelectedCondition(i,'field')"
          [nzNotFoundContent]="isSelectLoading ? loadingTemplate : ''"
          [nzPlaceHolder]="'Select field'  | translate"
          [ngClass]="{'error-border': condition.invalidField}">
          <nz-option *ngFor="let attr of filterOptions[i]" [nzLabel]="attr.Label" [nzValue]="attr.Id">

          </nz-option>

        </nz-select>

        <nz-select nzAllowClear [(ngModel)]="condition.operator" (ngModelChange)="updateSelectedCondition(i,'operator')"
          [nzPlaceHolder]="'Select Operator'  | translate">
          <nz-option *ngFor="let operator of operators" [nzLabel]="operator.label"
            [nzValue]="operator.value"></nz-option>
        </nz-select>
        

        <nz-select *ngIf="condition.typeFiled=='select'"
         nzAllowClear [(ngModel)]="condition.value"
          (ngModelChange)="updateSelectedCondition(i,'select')"
           [nzPlaceHolder]="'Select value' | translate"
          [nzDisabled]="isFieldDisabled(condition)"
        
          >
          <nz-option *ngFor="let option of attributeOptions[i]"
           [nzLabel]="option.Name" [nzValue]="option.Id">

          </nz-option>
        </nz-select>

 
        <input *ngIf="condition.typeFiled!=='select'" nz-input [(ngModel)]="condition.value"
          (ngModelChange)="updateSelectedCondition(i,'other')" 
           [disabled]="isFieldDisabled(condition)"
          [type]="condition.typeFiled" (blur)="onFieldBlur(i)" [placeholder]="'Enter value' | translate" 
           class="input-value"/>

   


        <span class="delete" nz-icon nzType="delete" nzTheme="outline" (click)="removeCondition(i)"
          [class.disabled]="conditions.length === 1"></span>
      </div>


      <div nz-col nzSpan="24">
        <button nz-button nzType="dashed" (click)="addCondition()">
          <span nz-icon nzType="plus-circle" nzTheme="outline"></span> {{'Add new condition' | translate}}</button>
      </div>
    </div>
  </div>
</div> 

<ng-template #loadingTemplate>
  <div class="d-flex justify-content-center align-items-center py-2">
    <nz-spin size="small" style="margin-top: 10px;"></nz-spin>
    <span class="ms-2">Loading ...</span>
  </div>
</ng-template>
